
import React, { useState, useContext, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import Badge from '@material-ui/core/Badge';
import IconButton from '@material-ui/core/IconButton';
import ArrowForward from "@material-ui/icons/ArrowForward";
import Icon from '@material-ui/core/Icon';
import PropTypes from 'prop-types';
import axios from "axios";
import moment from 'moment';
import Tooltip from '@material-ui/core/Tooltip';
import pdfMake from "pdfmake/build/pdfmake";
import TablePagination from '@material-ui/core/TablePagination';
import Divider from '@material-ui/core/Divider';
import Libros from '@material-ui/icons/ViewList';
import ModalLibros from 'App/components/ModalLibros'
import RemoteTable from 'App/components/RemoteTable';
import { DigitoVerificador, useDateInput, useFormInput } from "App/Helpers/Genericos";
import PrintIcon from "@material-ui/icons/Print";
import Code from "@material-ui/icons/Code";
import { Estado, TipoDoc } from 'App/Helpers/Iconos';
import { LayoutContext } from 'App/Layout/store';
import { RecibidosContext } from 'App/Recibidos/store';
import { CesionContext } from 'App/Cesion/store';
import _ from 'underscore';
import ConvertXML from 'xml-js';
import DetallesDTE from './DetallesDTE';
import Switch from '@material-ui/core/Switch';
import { FormControl, Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@material-ui/core';
import Close from '@material-ui/icons/Close';
import { CrearDTE } from 'App/Emitidos/Actions';
import Select from 'react-select';
import { Label } from '@material-ui/icons';
import Swal from 'sweetalert2'

const YellowBadge = withStyles(theme => ({
    badge: {
        fontSize: 8,
        backgroundColor: 'yellow'
    },
}))(Badge);
const StyledBadge = withStyles(theme => ({
    badge: {
        fontSize: 8
    },
}))(Badge);

const styles = theme => ({
    root: {
        width: "100%",
        marginTop: theme.spacing.unit * 3
    },
    table: {
        minWidth: 500
    },
    tableWrapper: {
        overflowX: "auto"
    }
});

function parseXmlToJson(xml) {
    const json = {};
    for (const res of xml.matchAll(/(?:<(\w*)(?:\s[^>]*)*>)((?:(?!<\1).)*)(?:<\/\1>)|<(\w*)(?:\s*)*\/>/gm)) {
        const key = res[1] || res[3];
        const value = res[2] && parseXmlToJson(res[2]);
        json[key] = ((value && Object.keys(value).length) ? value : res[2]) || null;

    }
    return json;
}

function groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item, i) => {
        const key = keyGetter(item, i);
        const collection = map.get(key);
        if (!collection) {
            map.set(key, [item]);
        } else {
            collection.push(item);
        }
    });
    return map;
}

const DialogEtiquetas = React.memo(({layoutContext,abreSetTags,setAbreSetTags,tags,setTags,parentProps,selectedRows,actualizaTabla})=> <Dialog
                    maxWidth="sm"
                    fullWidth
                    open={abreSetTags}
                    onClose={() => setAbreSetTags(false)}>
                    <DialogTitle>Editar Etiquetas</DialogTitle>
                    <DialogContent style={{ minHeight: 250 }}>
                        <h4>Agregar estas etiquetas</h4>
                        <Select
                            placeholder='Etiqueta'
                            isMulti
                            menuPosition="fixed"
                            value={tags.agregar.map(o => ({ label: layoutContext.state.tags?.find(d => d.id_tag == o)?.nombre, value: o }))}
                            styles={{
                                menu: provided => ({ ...provided, zIndex: 9999 })
                            }}
                            options={layoutContext.state.tags?.filter(e => e.b_activo && !tags.quitar.some(q => q == e.id_tag))
                                ?.map(e => ({ label: e.nombre, value: e.id_tag }))}
                            onChange={e => {
                                setTags({ ...tags, agregar: e.map(o => o.value) })
                            }}
                        />

                        <h4>Quitar estas etiquetas</h4>
                        <Select
                            placeholder='Etiqueta'
                            isMulti
                            menuPosition="fixed"
                            value={tags.quitar.map(o => ({ label: layoutContext.state.tags?.find(d => d.id_tag == o)?.nombre, value: o }))}
                            styles={{
                                menu: provided => ({ ...provided, zIndex: 9999 })
                            }}
                            options={layoutContext.state.tags?.filter(e => e.b_activo && !tags.agregar.some(q => q == e.id_tag))
                                ?.map(e => ({ label: e.nombre, value: e.id_tag }))}
                            onChange={e => {
                                setTags({ ...tags, quitar: e.map(o => o.value) })
                            }}
                        />

                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setAbreSetTags(false)} color="default">
                            Cancelar
                        </Button>
                        <Button onClick={() => {
                            axios.post(`/api/dte/${parentProps.tipoDTE}/etiquetar`, { ...tags, dtes: selectedRows.map(e => e.data[0]) })
                                .then(da => {
                                    Swal.fire("", "Cambios realizados exitosamente", "success")
                                    actualizaTabla()
                                })
                                .catch(e => console.error(e))
                                .finally(() => setAbreSetTags(false))

                        }} color="default">
                            Guardar
                        </Button>
                    </DialogActions>
                </Dialog>
)

export function Imprimir(tipoPapel, rows, cedible = false) {
    var win = window.open('/cargando.html', '_blank');
    function creaElementos(archivo) {
        var byteCharacters = atob(archivo);
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        let file = new Blob([byteArray], { type: "application/pdf;base64" });
        var blobHtmlElement;
        blobHtmlElement = document.createElement('object');
        blobHtmlElement.style.position = 'fixed';
        blobHtmlElement.style.top = '0';
        blobHtmlElement.style.left = '0';
        blobHtmlElement.style.bottom = '0';
        blobHtmlElement.style.right = '0';
        blobHtmlElement.style.width = '100%';
        blobHtmlElement.style.height = '100%';
        blobHtmlElement.setAttribute('type', 'application/pdf');
        blobHtmlElement.setAttribute('data', URL.createObjectURL(file));
        win.document.title = 'Asyntec DTE - Documento Tributario Electrónico';
        win.document.body.appendChild(blobHtmlElement);
    }
    axios.post("/api/imprimir" + (tipoPapel ? ("/papel/" + tipoPapel) : "") + (cedible ? "/Cedible" : ""), rows.map(e => e.id_dte)).then(function (response) {
        var abrir = () => {
            win.document.body.innerHTML = "";
            if (response.PDF) {
                if (rows.length > 25) {
                    const linkSource = `data:application/pdf;base64,${response.PDF}`;
                    const downloadLink = document.createElement("a");
                    const fileName = "impresion_dte.pdf";
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                    win.close();
                } else {
                    creaElementos(response.PDF);
                }
            } else if (response.PDFMake) {
                if (rows.length > 25) {
                    pdfMake.createPdf(response.PDFMake).download()
                    win.close();
                } else {
                    var doc = pdfMake.createPdf(response.PDFMake)
                    var callback = function (url) {
                        creaElementos(url.replace("data:application/pdf;base64,", ""));
                    }
                    doc.getDataUrl(callback, doc);
                }
            } else {
                win.close();
            }
        }
        if (win.document.body) {
            abrir();
        } else {
            win.onload = abrir;
        }
    }).catch(e => { console.log(e); win.close() });
}

export function DescargarXML(id_dte, tipoXML) { //tipoXML: "TED" || "DTE"

    axios.get("/api/DTE/Xml/" + id_dte + "/" + tipoXML).then((data) => {
        if (data.XML) {
            var uri = 'data:text/plain,' + encodeURIComponent(data.XML)
            var downloadLink = document.createElement("a");
            downloadLink.href = uri;
            downloadLink.download = id_dte + "_" + tipoXML + ".xml";

            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        } else {
            alert(tipoXML + " no disponible.");
        }
    }).catch(e => console.error(e))
}

function DescargarXMLMasivo(tipo, rows) {
    axios.post("/api/DTE/Xml/" + tipo, rows.map(e => e.id_dte)).then(function (data) {
        if (data.XML) {
            var uri = 'data:text/plain,' + encodeURIComponent(data.XML)
            var downloadLink = document.createElement("a");
            downloadLink.href = uri;
            downloadLink.download = data.TipoDoc + ".xml";
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        } else {
            alert("Descarga de" + data.TipoDoc + ".xml no disponible.");
        }
    }).catch(e => console.error(e))
}
function TablaDTE(props) {
    const { classes } = props;
    const cliente = useFormInput('', 'Cliente/RUT')
    const [tipoDocumento, setTipoDocumento] = useState([])
    const [etiqueta, setEtiqueta] = useState([])
    const [sinEtiqueta, setSinEtiqueta] = useState([])
    const estado = useFormInput('Aceptados', 'Estado')
    const tipoFecha = useFormInput('CO', 'Tipo Fecha')
    const folio = useFormInput(null, 'Folio Desde', {
        InputLabelProps: {
            shrink: true,
        }
    })
    const folioh = useFormInput(null, 'Folio Hasta', {
        InputLabelProps: {
            shrink: true,
        }
    })
    const desde = useDateInput(moment().startOf('month').format('YYYY-MM-DD'), 'Desde');
    const hasta = useDateInput(moment().endOf('month').format('YYYY-MM-DD'), 'Hasta');
    const [abreMenu, setAbreMenu] = useState(false);
    const [anchorMenu, setAnchorMenu] = useState(null);
    const [currentDte, setCurrentDte] = useState(-1);
    const [abreDetalles, setAbreDetalles] = useState(false);
    const [filasTabla, setFilasTabla] = useState({});
    const [cargando, setCargando] = useState(-1);
    const [modoFecha, setModoFecha] = useState(false);
    const [abreSetTags, setAbreSetTags] = useState(false);
    const [selectedRows, setSelectedRows] = useState([])
    const [tags, setTags] = useState({ agregar: [], quitar: [] });

    const layoutContext = useContext(LayoutContext);
    const recibidosContext = useContext(RecibidosContext);
    const cesionContext = useContext(CesionContext);

    const [data, setData] = useState({
        desde: desde.value,
        hasta: hasta.value
    });

    function actualizaTabla(d, noBloquea = false) {
        if (!cargando || cargando == -1) {
            setCargando(true)
            setData(d);
            if (d.pagnueva) {
                d.pagina = 0
                delete (d.pagnueva);
            }
            axios.post("/api/dte/" + props.tipoDTE, d, { noBloquea })
                .then(da => { setFilasTabla(da) })
                .catch(e => console.error(e))
                .finally(() => setCargando(false))
        }
    }

    useEffect(() => {
        if (layoutContext.state.nuevoDte.emitidos > 0 && props.tipoDTE == "emitidos") {
            layoutContext.dispatch({ type: 'actualizaDteNuevo', cant: -layoutContext.state.nuevoDte.emitidos, tipo: true })
            if (!cargando) { actualizaTabla(data, true) }
        }
        if (layoutContext.state.nuevoDte.recibidos > 0 && props.tipoDTE == "recibidos") {
            layoutContext.dispatch({ type: 'actualizaDteNuevo', cant: -layoutContext.state.nuevoDte.recibidos, tipo: false })
            if (!cargando) { actualizaTabla(data, true) }
        }
    }, [layoutContext.state.nuevoDte.emitidos, layoutContext.state.nuevoDte.recibidos])

    useEffect(() => {
        var cambio = false;
        layoutContext.state.cambioDte.forEach(i => {
            var fila = _.find(filasTabla.datos, { id_dte: i.id });
            if (fila) {
                fila.estado = i.estado;
                cambio = true;
            }
        })
        if (cambio) setFilasTabla({ ...filasTabla, update: moment() });
    }, [layoutContext.state.cambioDte])

    useEffect(() => {
        var cambio = false;
        layoutContext.state.cambioRcv.forEach(i => {
            var fila = _.find(filasTabla.datos, { id_dte: i.id });
            if (fila) {
                fila.rcv = i.evento;
                cambio = true;
            }
        })
        if (cambio) setFilasTabla({ ...filasTabla, update: moment() });
    }, [layoutContext.state.cambioRcv])

    function onSearch(pagnueva = false) {
        var d = {
            tipoFecha: tipoFecha.value,
            desde: desde.value,
            hasta: hasta.value,
            folio: folio.value || folioh.value,
            folioh: folioh.value || folio.value,
            cliente: cliente.value == "" ? null : cliente.value,
            estado: estado.value,
            tipoDocumento: tipoDocumento,
            etiqueta: etiqueta,
            sinEtiqueta: sinEtiqueta
        }
        if (pagnueva) {
            d.pagnueva = true;
        }
        setData(d);
    }


    function AbreDocumento(data, AsociaNuevo = false) {
        axios({
            method: "get",
            url: "/api/dte/Id/" + data.rowData[0]
        }).then((dte) => {
            var json = JSON.parse(ConvertXML.xml2json(dte.Xml, { compact: true }));
            if (json.DTE.Documento.Detalle) {
                if (!Array.isArray(json.DTE.Documento.Detalle)) {
                    json.DTE.Documento.Detalle = [json.DTE.Documento.Detalle];
                }
            }
            if (json.DTE.Documento.Referencia) {
                if (!Array.isArray(json.DTE.Documento.Referencia)) {
                    json.DTE.Documento.Referencia = [json.DTE.Documento.Referencia];
                }
            }
            if (json.DTE.Documento.Detalle.length > 0) {
                for (var i = 0; i < json.DTE.Documento.Detalle.length; i++) {
                    if (json.DTE.Documento.Detalle[i].CdgItem) {
                        if (!Array.isArray(json.DTE.Documento.Detalle[i].CdgItem)) {
                            json.DTE.Documento.Detalle[i].CdgItem = [json.DTE.Documento.Detalle[i].CdgItem];
                        }
                    }
                }
            }
            if (AsociaNuevo) {
                json.DTE.Documento.Referencia = [
                    {
                        NroLinRef: { _text: 1 },
                        TpoDocRef: { _text: json.DTE.Documento.Encabezado.IdDoc.TipoDTE._text },
                        FolioRef: json.DTE.Documento.Encabezado.IdDoc.Folio,
                        FchRef: { _text: json.DTE.Documento.Encabezado.IdDoc.FchEmis._text },
                        CodRef: {},
                        RazonRef: {}
                    }
                ]
                json.DTE.Documento.Encabezado.IdDoc.FchEmis._text = moment().format('YYYY-MM-DD')
                delete json.DTE.Documento.Encabezado.IdDoc.TipoDTE._text
            } else {
                json.DTE.Documento.Encabezado.IdDoc.IdDte = data.rowData[0]
            }
            layoutContext.dispatch({ type: "toggleNuevaVenta" });
            layoutContext.dispatch({ type: "setDteData", dteData: json });
        })
    }

    function onClickEstado(value, tableMeta) {
        switch (value) {
            case "Guardado":
                return () => { AbreDocumento(tableMeta) };
            default:
                return () => { setCurrentDte(tableMeta.rowData); setAbreDetalles(true) };
        }
    }

    function toggleMenu(event, dte) {
        setCurrentDte(dte);
        setAnchorMenu(!abreMenu ? event.target : null);
        setAbreMenu(!abreMenu);
    }

    function cerrarMenu() {
        setAbreMenu(false);
        setTimeout(() => {
            setCurrentDte(-1);
            setAnchorMenu(null);
        }, 500);
    }

    function BorrarDTE(id_dte) {
        axios({
            method: "delete",
            url: "/api/DTE/Borrar/" + id_dte
        }).then(() => {
            alert("DTE borrado con éxito");
            onSearch();
        }).catch((e) => {
            console.error(e);
            cerrarMenu();
        })
    }

    const ITEM_HEIGHT = 48;

    const columns = [
        { name: "ID", key: "id_dte", options: { display: false } },
        { name: "Rut", key: "rut", options: { customBodyRender: (value, tableMeta, updateValue) => { return value ? (value.toLocaleString() + "-" + DigitoVerificador(value)) : "" } } },
        { name: (props.tipoDTE == "recibidos" ? "Emisor" : "Receptor"), key: "razon_social" },
        { name: "Tipo", key: "tipo_dte", options: { customBodyRender: (value, tableMeta, updateValue) => { return TipoDoc(value, undefined, tableMeta.rowData[15]?.split(",")?.map(e => layoutContext.state.tags.find(t => t.id_tag == e))?.filter(e => e)) } } },
        { name: "Folio", key: "folio" },
        { name: "Creacion", key: "fecha_creacion", options: { sortDirection: 'desc', customBodyRender: (value, tableMeta, updateValue) => { return moment(value).format("L") } } },
        { name: "Emision", key: "fecha_emision", options: { customBodyRender: (value, tableMeta, updateValue) => { return moment(value).format("L") } } },
        { name: "$ Neto", key: "neto", options: { customBodyRender: (value, tableMeta, updateValue) => { return (value || 0).toLocaleString() } } },
        { name: "$ Exento", key: "exento", options: { customBodyRender: (value, tableMeta, updateValue) => { return (value || 0).toLocaleString() } } },
        { name: "$ IVA", key: "IVA", options: { customBodyRender: (value, tableMeta, updateValue) => { return (value || 0).toLocaleString() } } },
        { name: "$ Total", key: "total", options: { customBodyRender: (value, tableMeta, updateValue) => { return (value || 0).toLocaleString() } } },
        {
            name: "Estado", key: "estado", options: {
                customBodyRender: (value, tableMeta, updateValue) => {
                    var rcv = tableMeta.rowData[13];
                    if (rcv && value != "Guardado") {
                        if (rcv == 'CON') {
                            return <YellowBadge badgeContent={rcv}>
                                {Estado(value, rcv, onClickEstado(value, tableMeta))}
                            </YellowBadge>
                        } else {
                            return <StyledBadge badgeContent={rcv} color={rcv[0] == 'R' || rcv == "NCA" || rcv == "ENC" ? "secondary" : "primary"}>
                                {Estado(value, rcv, onClickEstado(value, tableMeta))}
                            </StyledBadge>
                        }
                    } else {
                        return Estado(value, rcv, onClickEstado(value, tableMeta))
                    }
                }
            }
        },
        {
            name: "Acciones", key: "acciones", options: {
                customBodyRender: (value, tableMeta, updateValue) => {
                    var meta = tableMeta;
                    var rowData = tableMeta.rowData;
                    var id = (rowData || [false])[0];
                    var externo = false;//((tableMeta.rowData || { 11: "" })[11]).toLowerCase().includes("extern");
                    return <div>
                        <IconButton onClick={(event) => {
                            toggleMenu(event, rowData)
                        }
                        }>
                            <Icon>more_vert</Icon>
                        </IconButton>
                        {id && !externo ?
                            <IconButton onClick={() => Imprimir(null, [{ id_dte: id }])}>
                                <PrintIcon />
                            </IconButton>
                            : null}
                    </div>
                },
                sort: false
            }
        },
        { name: "RCV", key: "rcv", options: { display: false } },
        { name: "CreacionFull", key: "fecha_creacion", options: { display: false } },
        { name: "Etiquetas", key: "etiquetas", options: { display: false } },
        { name: "Tipo2", key: "tipo_dte", options: { display: false } },
        { name: "cod_tipo", key: "cod_tipo", options: { display: false } }
    ]

    //var folioIndex = _.findIndex(columns, function (column) { return column.key == "folio" });
    var estadoIndex = _.findIndex(columns, function (column) { return column.key == "estado" });
    var dteData = {}
    _.each(currentDte, (item, ix) => {
        dteData[columns[ix].key] = item;
    });
    return (
        <div>
            <Grid container spacing={24}>
                <Grid item xs={7}>
                    <Grid container spacing={24}>
                        <Grid item xs={2}>
                            <TextField {...cliente} />
                        </Grid>
                        <Grid item xs={3}>
                            <FormControl fullWidth className={classes.formControl}>
                                <Select
                                    placeholder='Tipos de Documento'
                                    isMulti
                                    value={tipoDocumento.map(o => ({ label: layoutContext.state.tiposDoc?.find(d => d.ID == o)?.Nombre, value: o }))}
                                    styles={{
                                        menu: provided => ({ ...provided, zIndex: 9999 })
                                    }}
                                    options={layoutContext.state.tiposDoc?.filter(e => e.Electronico)
                                        ?.filter(o => layoutContext.state.datosEmpresa?.Permisos?.some(d => d.Nombre.toLowerCase() == props.tipoDTE?.toLowerCase() && (!d.TiposDoc.filter(f => f > 0).length || d.TiposDoc.includes(o.ID))))
                                        ?.map(e => ({ label: e.Nombre, value: e.ID }))}
                                    onChange={e => {
                                        setTipoDocumento(e.map(o => o.value))
                                    }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={3}>
                            <Grid container spacing={24}>
                                <Grid item xs={6}>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <Select
                                            placeholder='+ Etiqueta'
                                            isMulti
                                            value={etiqueta.map(o => ({ label: layoutContext.state.tags?.find(d => d.id_tag == o)?.nombre, value: o }))}
                                            styles={{
                                                menu: provided => ({ ...provided, zIndex: 9999 })
                                            }}
                                            options={layoutContext.state.tags?.filter(e => e.b_activo)
                                                ?.map(e => ({ label: e.nombre, value: e.id_tag }))}
                                            onChange={e => {
                                                setEtiqueta(e.map(o => o.value))
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <Select
                                            placeholder='- Etiqueta'
                                            isMulti
                                            value={sinEtiqueta.map(o => ({ label: layoutContext.state.tags?.find(d => d.id_tag == o)?.nombre, value: o }))}
                                            styles={{
                                                menu: provided => ({ ...provided, zIndex: 9999 })
                                            }}
                                            options={layoutContext.state.tags?.filter(e => e.b_activo)
                                                ?.map(e => ({ label: e.nombre, value: e.id_tag }))}
                                            onChange={e => {
                                                setSinEtiqueta(e.map(o => o.value))
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={2}>
                            <Grid container spacing={0}>
                                <Grid item xs={6}>
                                    <TextField {...folio} />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField {...folioh} />
                                </Grid>
                            </Grid>
                        </Grid>


                        <Grid item xs={2}>
                            <TextField select InputLabelProps={{ shrink: true }} {...tipoFecha}>
                                <MenuItem value={"CO"} defaultChecked>Contable</MenuItem>
                                <MenuItem value={"EM"} >Emisión</MenuItem>
                                <MenuItem value={"CR"}>Creación</MenuItem>
                                {/* <MenuItem value={"FV"}>Vencimiento</MenuItem> */}
                            </TextField>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={3}>
                    <Grid container spacing={0}>
                        <Grid item xs={2}>
                            <Switch size="small" checked={modoFecha}
                                onChange={() => {
                                    if (modoFecha) {
                                        //pasamos al modo simple. cambiamos fechas al mes completo
                                        desde.onChange({ target: { value: moment(desde.value).startOf('month').format('YYYY-MM-DD') } })
                                        hasta.onChange({ target: { value: moment(desde.value).endOf('month').format('YYYY-MM-DD') } })
                                    }
                                    setModoFecha(!modoFecha)
                                }} />
                        </Grid>
                        <Grid item xs={modoFecha ? 5 : 10}>
                            {modoFecha ?
                                <TextField {...desde} />
                                :
                                <TextField InputLabelProps={{ shrink: true }}
                                    fullWidth
                                    label="Mes"
                                    type="month"
                                    value={moment(desde.value).format("YYYY-MM")}
                                    onChange={e => {
                                        var nuevaFecha = moment(e.target.value)
                                        desde.onChange({ target: { value: nuevaFecha.startOf('month').format('YYYY-MM-DD') } })
                                        hasta.onChange({ target: { value: nuevaFecha.endOf('month').format('YYYY-MM-DD') } })
                                    }}
                                />
                            }
                        </Grid>
                        {modoFecha ? <Grid item xs={5}>
                            <TextField {...hasta} />
                        </Grid> : null}
                    </Grid>
                </Grid>
                <Grid item xs={1}>
                    <TextField select InputLabelProps={{ shrink: true }} {...estado}>
                        <MenuItem value={"Todos"}>Todos</MenuItem>
                        <MenuItem value={"Aceptados"} defaultChecked>Aceptados SII</MenuItem>
                        <MenuItem value={"Rechazados"}>Rechazados SII</MenuItem>
                        <MenuItem value={"PendientesComercial"}>Pendientes Respuesta Comercial</MenuItem>
                        <MenuItem value={"AceptadosComercial"}>Aceptados Comercial</MenuItem>
                        <MenuItem value={"RecibidosComercial"}>Recibidos Comercial</MenuItem>
                        <MenuItem value={"RechazadosComercial"}>Rechazados Comercial</MenuItem>
                    </TextField>
                </Grid>

                <Grid item xs={1}>
                    <IconButton color="primary" className={classes.button} aria-label="search" onClick={e => { e.preventDefault(); onSearch(true) }}>
                        <Icon>search</Icon>
                    </IconButton>
                </Grid>
                <Menu
                    id={"menu-descargar"}
                    anchorEl={anchorMenu}
                    open={abreMenu}
                    onClose={cerrarMenu}
                    disableAutoFocusItem={true}
                    PaperProps={{
                        style: {
                            maxHeight: ITEM_HEIGHT * 4.5,
                            width: 200,
                        },
                    }}>
                    <div>
                        {
                            currentDte[estadoIndex] != "Guardado" ?
                                <div>
                                    <MenuItem onClick={(evt) => { cerrarMenu(); DescargarXML(currentDte[0], "DTE"); }}>
                                        Descargar Documento
                                    </MenuItem>
                                    {currentDte[estadoIndex] != "Recibido en el SII" && <MenuItem onClick={(evt) => { cerrarMenu(); DescargarXML(currentDte[0], "TED"); }}>
                                        Descargar Timbre
                                    </MenuItem>}
                                </div>
                                :
                                null
                        }
                        {
                            props.tipoDTE == "recibidos" && (dteData || {}).rcv != 'CON' && ["Factura Electrónica", "Factura no Afecta o Exenta Electrónica", "Liquidación-Factura Electrónica"].indexOf((dteData || {}).tipo_dte) >= 0 && moment((dteData || {}).fecha_creacion).add(8, 'days').diff(moment().startOf('day')) > 0 ?
                                <MenuItem onClick={() => {
                                    cerrarMenu();
                                    recibidosContext.dispatch({ type: "setDocumentosRespuesta", data: [dteData] })
                                    recibidosContext.dispatch({ type: "toggleRespuestaComercial" });
                                }}>
                                    Respuesta comercial
                                </MenuItem>
                                :
                                null
                        }
                        <MenuItem onClick={(evt) => { cerrarMenu(); Imprimir(1, [{ id_dte: dteData.id_dte }]) }}>
                            Imprimir Papel Continuo
                        </MenuItem>
                        {
                            props.tipoDTE == "emitidos" && ["Factura Electrónica", "Factura no Afecta o Exenta Electrónica", "Liquidación-Factura Electrónica"].indexOf((dteData || {}).tipo_dte) > -1 ?
                                <div>
                                    <MenuItem onClick={(evt) => { cerrarMenu(); Imprimir(null, [{ id_dte: dteData.id_dte }], true) }}>
                                        Imprimir Copia Cedible
                                    </MenuItem>
                                    {(dteData || {}).rcv == "AUT" || (dteData || {}).rcv == "ERM" || (dteData || {}).rcv == "ACD" ?
                                        <MenuItem onClick={() => {
                                            cerrarMenu();
                                            cesionContext.dispatch({ type: "setDocumentoCesion", data: dteData })
                                            cesionContext.dispatch({ type: "toggleCesion" });
                                        }}>
                                            Cesión Electrónica
                                        </MenuItem>
                                        : null}
                                </div>
                                : null
                        }
                        {currentDte[estadoIndex] != "Enviado" && (currentDte[estadoIndex] || "").toLowerCase().indexOf("recibido") == -1 && currentDte[estadoIndex] != "Rechazado" ?
                            <div>
                                <Divider />
                                <MenuItem onClick={(evt) => {
                                    cerrarMenu();
                                    if (currentDte[estadoIndex] == "Guardado") {
                                        BorrarDTE(currentDte[0]);
                                    } else {
                                        AbreDocumento({ rowData: currentDte }, true);
                                    }
                                }}>
                                    {currentDte[estadoIndex] == "Guardado" ? "Eliminar DTE" : "Asociar Nuevo"}
                                </MenuItem></div> : null
                        }
                    </div>
                </Menu>
            </Grid>
            <ModalLibros />
            <DialogEtiquetas actualizaTabla={()=>actualizaTabla(data,true)} selectedRows={selectedRows} parentProps={props} layoutContext={layoutContext} abreSetTags={abreSetTags} setAbreSetTags={setAbreSetTags} tags={tags} setTags={setTags}/>
            <RemoteTable setSelectedRows={setSelectedRows} columns={columns} method={"post"} url={"/api/dte/" + props.tipoDTE} query={actualizaTabla} contenido={filasTabla} data={data} title={props.titulo} CustomToolBar={ParentCustomToolbarSelect(props, recibidosContext, layoutContext, columns, setAbreSetTags)} CustomFooter={CustomFooter} download></RemoteTable>
            <DetallesDTE abrir={abreDetalles} DTE={currentDte} cerrar={() => { setAbreDetalles(!abreDetalles) }} />
        </div>
    );
}

TablaDTE.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(React.memo(TablaDTE));


const defaultToolbarSelectStyles = {
    iconButton: {
        marginRight: "24px"
    }
};

function ParentCustomToolbarSelect(parentProps, recibidosContext, layoutContext, columns, setAbreSetTags) {

    function CustomToolbarSelect(props) {

        const handleClick = () => {
            Imprimir(null, props.selectedRows.map(e => { return { id_dte: e.data[0] } }))
        };

        const handleClickRCV = () => {
            var data = props.selectedRows.map(dat => {
                var e = {}
                _.each(dat.data, (item, ix) => {
                    e[columns[ix].key] = item;
                });
                e.fecha_emision = moment(e.fecha_emision, ["DD-MM-YYYY"]).toDate()
                return e;
            })

            recibidosContext.dispatch({ type: "setDocumentosRespuesta", data })
            recibidosContext.dispatch({ type: "toggleRespuestaComercial" });
        };

        const handleAnularMasivo = () => {
            var tipos = Array.from(groupBy(props.selectedRows.map(dat => {
                var e = {}
                _.each(dat.data, (item, ix) => {
                    e[columns[ix].key] = item;
                });
                e.fecha_emision = moment(e.fecha_emision, ["DD-MM-YYYY"]).format("YYYY-MM-DD")
                return e;
            }), e => e.tipo_dte)).map(e => {
                return Array.from(groupBy(e[1], k => k.rut)).map(k => {
                    return Array.from(groupBy(k[1], (j, i) => Math.floor(i / ([39, 41].includes(j.tipo_dte) ? 40 : 1)))).map(l => l[1])
                })
            })

            tipos = tipos.flat(2)

            if (window.confirm(`Se generarán ${tipos.length} documentos de anulación y se enviarán al SII. \n\nESTA ACCION NO ES REVERSIBLE. \n\nEstá seguro?`)) {
                //emititmos documentos directamente
                props.setSelectedRows([])
                axios.post("/api/DTE/Xml/DTE", tipos.map(e => e[0].id_dte)).then(d => {
                    var parser = new DOMParser();
                    var xmlDoc = parser.parseFromString(d.XML, "text/xml");

                    var receptores = Array.from(xmlDoc.getElementsByTagName("Receptor")).map(e => parseXmlToJson(e.innerHTML))

                    CrearDTE(tipos.map(e => {
                        var ret = {
                            Encabezado: {
                                IdDoc: {
                                    TipoDTE: e[0].tipo_dte == "Nota de Crédito Electrónica" ? 56 : 61,
                                    FchEmis: moment().format("YYYY-MM-DD"),
                                },
                                Receptor: receptores.find(k => (k.RUTReceptor || k.RUTRecep) == e[0].rut.replace(/\./g, ''))
                            },
                            Detalle: []
                        };
                        if (e.some(k => k.neto.replace(/\./g, '') * 1)) {
                            var MontoItem = e.reduce((m, k) => m + k.neto.replace(/\./g, '') * 1, 0);
                            var IVA = e.reduce((m, k) => m + k.IVA.replace(/\./g, '') * 1, 0);
                            if (Math.round(MontoItem * 0.19) != IVA) {
                                ret.Encabezado.IdDoc.MntBruto = 1;
                                MontoItem = MontoItem + IVA
                            }
                            ret.Detalle.push({
                                NroLinDet: 1,
                                NmbItem: `Anulación de ${e.filter(k => k.neto.replace(/\./g, '') * 1).length} documento${e.length > 1 ? "s" : ""}`,
                                DscItem: `Monto Afecto`,
                                MontoItem
                            })
                        }
                        if (e.some(k => k.exento.replace(/\./g, '') * 1)) {
                            ret.Detalle.push({
                                NroLinDet: 1,
                                NmbItem: `Anulación de ${e.filter(k => k.exento.replace(/\./g, '') * 1).length} documento${e.length > 1 ? "s" : ""}`,
                                DscItem: `Monto Exento`,
                                MontoItem: e.reduce((m, k) => m + k.exento.replace(/\./g, '') * 1, 0),
                                IndExe: 1
                            })
                        }
                        ret.Referencia = e.map((k, i) => ({
                            NroLinRef: i + 1,
                            TpoDocRef: (layoutContext.state.tiposDoc.find(o => o.Nombre == k.tipo_dte) || {}).ID,
                            FolioRef: k.folio,
                            FchRef: k.fecha_emision,
                            CodRef: 1,
                            RazonRef: 'Se anula documento ' + k.folio
                        }))
                        return ret;
                    }), false, false, () => {
                        alert("Documentos creados exitosamente")
                    }, (error) => {
                        alert(error)
                    })

                }).catch(e => {
                    alert(e)
                })
            }
        };

        const handleClickAgregaDTEMasivo = () => {
            layoutContext.dispatch({ type: "agregaDteLibro", dtesLibro: props.selectedRows.map(e => { return { IdDte: e.data[0] } }) })
        };

        const handleClickXMLMasivo = () => {
            DescargarXMLMasivo(parentProps.tipoDTE, props.selectedRows.map(e => { return { id_dte: e.data[0] } }))
        };
        const { classes } = props;

        /* if (props.selectedRows.length == props.selectedRows.reduce((a, e) => a + (e.data[11].props.title.toLowerCase().includes("otro sistema") ? 1 : 0), 0)) {
            return null;
        } */
        return (
            <div className={"custom-toolbar-select"}>
                {parentProps.tipoDTE == "emitidos" && _.all(props.selectedRows, dteData => dteData.data[16].indexOf(/electr/g))
                    ?
                    <Tooltip title="Anular Documentos">
                        <IconButton className={classes.iconButton} onClick={handleAnularMasivo}>
                            <Close />
                        </IconButton>
                    </Tooltip> : null}
                <Tooltip title={"Agregar a Libro"}>
                    <IconButton className={classes.iconButton} onClick={handleClickAgregaDTEMasivo}>
                        <Libros />
                    </IconButton>
                </Tooltip>
                <Tooltip title={"Imprimir"}>
                    <IconButton className={classes.iconButton} onClick={handleClick}>
                        <PrintIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title={"Descargar XML"}>
                    <IconButton className={classes.iconButton} onClick={handleClickXMLMasivo}>
                        <Code />
                    </IconButton>
                </Tooltip>
                {layoutContext.state.datosEmpresa?.Permisos?.some(d => d.Nombre.toLowerCase() == (parentProps.tipoDTE?.toLowerCase() + "/etiquetar") && d.BEscritura && (!d.TiposDoc.filter(f => f > 0).length || props.selectedRows.every(r => d.TiposDoc.includes(r.data[17])))) ?
                    <Tooltip title="Etiquetas">
                        <IconButton className={classes.iconButton} onClick={e => setAbreSetTags(true)}>
                            <Label />
                        </IconButton>
                    </Tooltip> : null}
                {parentProps.tipoDTE == "recibidos" &&
                    _.all(props.selectedRows,
                        dteData => dteData.data[13] != 'CON' && ["Factura Electrónica", "Factura no Afecta o Exenta Electrónica", "Liquidación-Factura Electrónica"].indexOf(dteData.data[3].props.label) >= 0 && moment(dteData.data[14]).add(8, 'days').diff(moment().startOf('day')) > 0
                    )
                    ?
                    <Tooltip title={"Respuesta Comercial"}>
                        <IconButton className={classes.iconButton} onClick={handleClickRCV}>
                            <ArrowForward />
                        </IconButton>
                    </Tooltip> : null}
            </div>
        );

    }
    var CustomToolBar = withStyles(defaultToolbarSelectStyles, {
        name: "CustomToolbarSelect"
    })(CustomToolbarSelect);
    return CustomToolBar;
}

function CustomFooter(count, page, rowsPerPage, changeRowsPerPage, changePage) {
    return <TablePagination
        rowsPerPageOptions={[25, 50, 100, 1000]}
        component="div"
        count={count}
        rowsPerPage={rowsPerPage}
        page={page}
        labelRowsPerPage="Filas por página"
        backIconButtonProps={{
            'aria-label': 'Página anterior',
        }}
        nextIconButtonProps={{
            'aria-label': 'Página siguiente',
        }}
        onChangePage={(evt, page) => { changePage(page) }}
        onChangeRowsPerPage={(evt) => { changeRowsPerPage(evt.target.value) }}
    />
}